import React, { useState } from 'react';
import { Portal } from 'react-overlays';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-loading-skeleton/dist/skeleton.css';
import polygon_arrow from '../../assets/images/Polygon-arrow.svg';
import { format, startOfWeek, addDays, isSameDay, lastDayOfWeek, isFirstDayOfMonth, isSunday, isPast } from 'date-fns';

export default function Calendar({ activities, allClasses }) {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [hovered, setHovered] = useState(null);
  let sevenDaysLater = new Date(new Date());
  sevenDaysLater.setDate(new Date().getDate() + 7);

  const renderHeader = () => {
    const dateFormat = 'MMM yyyy';
    return (
      <h1 className='ft_16_calendar'>
        <span>{format(currentMonth, dateFormat)}</span>
      </h1>
    );
  };

  const renderDays = () => {
    const dayNames = ['Sun', 'M', 'Tu', 'W', 'Th', 'F', 'Sat'];
    const days = dayNames.map((dayName, index) => {
      // Define the desired text color for "Sun" and "Sat"
      const textColor = dayName === 'Sun' || dayName === 'Sat' ? '#76736F' : '#000';

      return (
        <li className='col col-center' key={index} style={{ color: textColor }}>
          {dayName}
        </li>
      );
    });

    return <ul className='list'>{days}</ul>;
  };

  const renderCells = () => {
    const startDate = startOfWeek(currentMonth, { weekStartsOn: 0 });
    const endDate = lastDayOfWeek(currentMonth, { weekStartsOn: 0 });
    const dateFormat = 'd';
    const rows = [];
    let days = [];
    let day = startDate;

    while (day <= endDate) {
      for (let i = 0; i < 21; i++) {
        const formattedDate = format(day, dateFormat);
        const cloneDay = day;
        // const dueClassesForDay = getDueClassesForDay(day);
        // const hasActivities = dueClassesForDay.length > 0;
        let hasActivities = activities.findIndex((e) => isSameDay(cloneDay, new Date(e.assignedDate)));
        let hasCompletedActivities = activities.findIndex((e) => isSameDay(cloneDay, new Date(e.assignedDate)) && !e.activityAnswers.some((x) => !x.isGraded));
        hasActivities = hasActivities > -1;
        hasCompletedActivities = hasCompletedActivities > -1;
        const isToday = isSameDay(day, new Date());
        const isItPast = isPast(cloneDay, new Date());
        const isItWeekend = isSunday(cloneDay, new Date()) || isFirstDayOfMonth(day, new Date());
        let className = 'normal-day';
        className = isToday ? 'isToday' : isItWeekend && hasCompletedActivities ? 'completed-weekend' : isItWeekend && !hasActivities ? 'weekend' : isItWeekend && hasActivities ? 'assigned-weekend' : isItPast && hasCompletedActivities ? 'completed-past' : !isItPast && hasCompletedActivities ? 'completed-future' : hasActivities && !isItPast ? 'assignment-day-future' : hasActivities && isItPast ? 'assignment-day-past' : isItPast && !hasActivities ? 'past' : 'future';
        days.push(
          <div
            className={`col cell `}
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            key={day}
            onMouseEnter={() => setHovered(Number(formattedDate))}
            onMouseLeave={() => setHovered(null)}
          >
            <p
              style={{
                position: 'relative',
                marginBottom: '0px',
              }}
              className={`cust-days cursor ${className} `}
              onMouseEnter={() => {
                // setTimeout(() => {
                setHovered(Number(formattedDate));
                // }, 1000);
              }}
              onMouseLeave={() => setHovered(null)}
            >
              {formattedDate}
            </p>
            {hovered === Number(formattedDate) && hasActivities && (
              <div>
                <div>{renderTooltip(cloneDay)}</div>
              </div>
            )}
          </div>
        );
        day = addDays(day, 1);
      }

      rows.push(
        <div className='row-calendar' style={{ marginLeft: '-2px' }} key={day}>
          {days}
        </div>
      );
      days = [];
    }

    return (
      <div className='body' style={{ marginLeft: '0px' }}>
        {rows}
      </div>
    );
  };

  const renderTooltip = (days) => {
    const formattedDate = format(new Date(), 'yyyy-MM-dd');
    const date = new Date(days);
    const day = date.toLocaleString('en-US', { weekday: 'short' }).slice(0, 2);

    return (
      <div>
        <div
          className='calendar_tooltip_box'
          style={{
            justifyContent: 'center',
            zIndex: '9999999',
            left: day === 'Sa' ? '-152%' : day === 'Su' ? '15%' : '-70%',
          }}
        >
          <il
            className='tooltip_text'
            /* style={{
                paddingBottom: "6px",
                minWidth: "200px",
                flexDirection: "column",
                gap: "4px",
              }} */
          >
            <div>
              <span style={{ textTransform: 'uppercase' }}></span>
              <div className='fw-400' style={{ display: 'inline' }}>
                <b>
                  {
                    // allClasses.activities.filter(
                    //   (e) =>
                    //     format(new Date(e.assignedDate), "yyyy-MM-dd") ===
                    //     formattedDate
                    // ).length
                    activities.filter((e) => format(new Date(e.assignedDate), 'yyyy-MM-dd') === formattedDate).length
                  }
                </b>{' '}
                activities due
              </div>
            </div>
          </il>
          <div
            className='arrow-frame'
            style={{
              position: 'absolute',
              bottom: '-9px',
              right: day === 'Sa' ? '0px' : day === 'Su' ? '74%' : '',
              padding: day === 'Su' ? '0px 6px' : '',
            }}
          >
            <img className='arrow_down' src={polygon_arrow} alt='polygon arrow' />
          </div>
        </div>
      </div>
    );
  };

  const customDayStyle = (date, activity) => {
    const now = new Date();
    const assignment = new Date(activity.assignedDate);
    const isActivity = activities.findIndex((e) => new Date(e.assignedDate).getDate() === date.getDate() && new Date(e.assignedDate).getMonth() === date.getMonth() && new Date(e.assignedDate).getFullYear() === date.getFullYear());
    if (date.getDate() === assignment.getDate() && date.getMonth() === assignment.getMonth() && date.getFullYear() === assignment.getFullYear()) {
      return 'assigned-day assignment-day future';
    } else if (date.getDate() === 1) {
      return 'first-day';
    } else if (isActivity >= 0) {
      if ((date.getDate() > now.getDate() && date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && now.getMonth() < date.getMonth())) {
        return 'assignment-day future';
      } else {
        return 'assignment-day past';
      }
    } else if (date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()) {
      return 'current-day';
    } else if (date.getDay() === 0) {
      return 'sunday';
    } else if ((date.getDate() > now.getDate() && date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && now.getMonth() < date.getMonth())) {
      return 'future-day';
    } else {
      return 'normal-day';
    }
  };
  const CalendarContainer = ({ children }) => {
    const el = document.getElementById('calendar-portal');
    return <Portal container={el}> {children} </Portal>;
  };

  return (
    <div
      className='border_shadow'
      style={{
        padding: '12px 6px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flexShrink: 0,
      }}
    >
      {/*<DatePicker
        selected={undefined}
        open
        renderDayContents={(day, date) => (
          <div className={customDayStyle(date, { assignedDate: "03/14/2024" })}>
            {day}
          </div>
        )}
        className="react-datepicker"
        popperContainer={CalendarContainer}
        />*/}
      <div className='calendar'>
        {renderHeader()}
        <div className='custom_celander'>
          {renderDays()}
          {renderCells()}
        </div>
      </div>
    </div>
  );
}
